export const navigation = {
  logo: true,
  background: true,
}
